<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="平台管理" name="first">
				<div class="k-page-common">
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/resources/resources/uploadorderlist') || $parent.$parent.isAuthAction('admin/resources/resources/uploadpricelist') || $parent.$parent.isAuthAction('admin/resources/resources/uploadInvoicelist')">
								<div>
									<el-button type="primary" size="mini" @click="openUpload()" :disabled="disabledupload"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/uploadorderlist')">平台对账</el-button>
									<!-- <el-button type="primary" size="mini" @click="openUpload()" :disabled="disabled"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/uploadorderlist')">上传订单</el-button> -->
									<!-- <el-button type="primary" size="mini" @click="openUploadPrice()" :disabled="disabled"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/uploadpricelist')">更新刊例价</el-button> -->
									<el-button type="primary" size="mini" @click="openPlatformInvoice()"
										:disabled="multipleSelection.length <= 0"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/uploadInvoicelist')">平台收票</el-button>
								</div>
							</div>
							<div class="k-table-con radio">
								<el-table :data="tableData.data" style="width: 100%" row-key="id"
									:tree-props="{ children: 'children', hasChildren: 'hasChildren' }" border stripe ref="table"
									highlight-current-row @sort-change="sortChange" @select-all="onSelectAll"
									@selection-change="selectItem" @row-click="onSelectOp" :height="tableHeight">
									<el-table-column type="selection" align="center" width="60">
									</el-table-column>
									<el-table-column prop="id" label="ID" align="center" width="50">
									</el-table-column>
									<el-table-column prop="attachment" label="LOGO" width="100">
										<template slot-scope="scope">
											<img :src="scope.row.attachment" alt="" width="20" height="20">
										</template>
									</el-table-column>
									<el-table-column prop="platform_name" label="平台名称" width="120">
									</el-table-column>
									<el-table-column prop="company_service_rate" label="公司服务费率" width="150">
										<template slot-scope="scope">
											{{ scope.row.company_service_rate }}%
										</template>
									</el-table-column>
									<el-table-column prop="is_choose" label="是否可选" width="100">
										<template slot-scope="scope">
											<span style="font-weight: bold;" :style="{ color: scope.row.is_choose === '是' ? '#67C23A' : '#F56C6C' }">{{ scope.row.is_choose }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="refund_cost" label="退款可抵扣总计" width="150"></el-table-column>
									<el-table-column label="退款已使用抵扣" width="150">
										<template slot-scope="scope">
											<el-popover placement="top" width="200" title="详情" trigger="hover">
												<div class="yhLine">
													<p style="font-weight: bold;color: #67C23A;"><i style="font-size:10px;"
															class="el-icon-star-on"></i> 待提交&nbsp;·····&nbsp;{{ scope.row.refund_dtj_cost }} 元</p>
													<p style="font-weight: bold;color: #E6A23C;"><i style="font-size:10px;"
															class="el-icon-star-on"></i> 待审核&nbsp;·····&nbsp;{{ scope.row.refund_dsh_cost }} 元</p>
													<p style="font-weight: bold;color: #F56C6C;"><i style="font-size:10px;"
															class="el-icon-star-on"></i> 已使用&nbsp;·····&nbsp;{{ scope.row.refund_cg_cost }} 元</p>
												</div>
												<p style="font-weight: bold;color: #409EFF;" slot="reference">{{ scope.row.refund_ysy_cost }}
												</p>
											</el-popover>
										</template>
									</el-table-column>
									<el-table-column prop="refund_yhx_cost" label="已核销金额" width="150">
									</el-table-column>
									<el-table-column prop="refund_sy_cost" label="退款剩余可抵扣" width="150">
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" min-width="200" sortable="custom">
									</el-table-column>
									<el-table-column prop="update_time" label="修改时间" min-width="200" sortable="custom">
									</el-table-column>
									<el-table-column
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/editplatform') || $parent.$parent.isAuthAction('admin/resources/resources/delplatform') || $parent.$parent.isAuthAction('admin/resources/resources/getplatforminfo')"
										fixed="right" label="操作" width="150">
										<template slot-scope="scope">
											<el-button @click.stop="handleTableEditOpen(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/editplatform')">编辑</el-button>
											<el-button @click.stop="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/delplatform')">
												删除
											</el-button>
											<el-button @click.stop="detail(scope.row)" type="text" :size="size" class="c-danger"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/getplatforminfo')">
												查看
											</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="total, prev, pager, next, sizes" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--编辑平台-->
		<el-dialog title="编辑平台" :close-on-click-modal="false" :visible.sync="editFormVisiable" v-loading="loading"
			width="40%">
			<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
				<div>
					<el-form-item label="平台名称" prop="platform_name">
						<el-input v-model="editForm.platform_name" placeholder="请填写平台名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="是否可选" prop="is_choose">
						<el-radio-group v-model="editForm.is_choose">
							<el-radio :label="0">否</el-radio>
							<el-radio :label="1">是</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="服务费(公司)">
						<el-input v-model="editForm.company_service_rate" placeholder="请填写服务费率(公司)" clearable>
							<template slot="append">%</template>
						</el-input>
					</el-form-item><!-- 
				<el-form-item label="服务费(个人)">
					<el-input v-model="editForm.personal_service_rate" placeholder="请填写服务费率(个人)" clearable>
					  	<template slot="append">%</template>
					  </el-input>
				</el-form-item> -->
					<el-form-item label="平台LOGO" prop="attachment">
						<el-upload action accept=".jpg,.jpeg,.png" :file-list="editForm.attachment"
							:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'attachment', true)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'editForm', 'attachment', true)">
							<el-button slot="trigger" size="mini">选取文件</el-button>
						</el-upload>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editplatform" :size='size'>提交</el-button>
				<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--上传订单-->
		<el-dialog title="上传订单" :close-on-click-modal="false" :visible.sync="addFormVisiable" v-loading="loading"
			width="40%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="130px">
				<div>
					<el-form-item label="下单账号:" prop="agent_id">
						<el-select v-model="addForm.agent_id" placeholder="请选择下单账户">
							<el-option v-for="item in options.agent_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="上传文件:" prop="excel_file">
						<el-upload drag ref="upload_excel_file" accept=".xls,.xlsx" action
							:http-request="(file) => { return imggreySuccess(file, 'excel_file_files') }"
							:file-list="uploadForm.excel_file_list"
							:on-remove="(file) => handleRemoveUpload2(file, 'excel_file_list')" :auto-upload="false"
							:on-exceed="limitMessage" :limit='1'>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text" style="font-size: 12px;">将文件拖到此处，或<em>点击上传</em><br /><span>支持 .xls
									.xlsx</span>
							</div>
							<div class="el-upload__tip" slot="tip"><a @click="downloadTemplate('order')" target="_blank"
									style="color: #409EFF; font-size: 12px; cursor: pointer;"><i class="el-icon-download"></i> 文件模板下载</a>
							</div>
						</el-upload>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addOrder()" :size='size'>提交</el-button>
				<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--平台收票-->
		<el-dialog title="平台收票" :close-on-click-modal="false" :visible.sync="addInvoiceVisiable" v-loading="loading"
			width="50%">
			<el-form :model="addInvoiceForm" ref="addInvoiceForm" :size="size" :rules="rules.addInvoiceForm"
				label-width="130px">
				<div>
					<el-form-item>
						<p style="color:red;">平台收票规则:</p>
						<p style="color:red;">1.需要收票的执行支出总额必须与选择的发票票面金额总额一致。</p>
						<p style="color:red;">2.只可统一收取【平台下单】的执行记录。</p>
						<p style="color:red;">3.数据下载只返回【平台下单】且【未收票】的【已对账】记录。</p>
						<p style="color:red;">4.表头列:执行明细编码、退款后实际支出、发票编号、收票金额。</p>
					</el-form-item>
					<el-form-item label="数据下载:">
						<el-date-picker @change="handleError" v-model="timeRangeValue" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
							type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
						<a @click="exportDuiZhangData()" :disabled="isDownloading" target="_blank"
							style="margin-left:10px;color: #409EFF; font-size: 12px; cursor: pointer;"><i
								class="el-icon-download"></i> {{
									isDownloading ? '下载中...' : '下载' }} </a>
					</el-form-item>
					<el-form-item label="上传文件:" prop="excel_file">
						<el-upload drag ref="upload_invoice_file" accept=".xls,.xlsx" action
							:http-request="(file) => { return imggreySuccessInvoice(file, 'excel_file_files') }"
							:file-list="uploadInvoiceForm.excel_file_list"
							:on-remove="(file) => handleRemoveUploadInvoice(file, 'excel_file_list')" :auto-upload="false"
							:on-exceed="limitMessage" :limit='1'>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text" style="font-size: 12px;">将文件拖到此处，或<em>点击上传</em><br /><span>支持 .xls
									.xlsx</span>
							</div>
							<!-- <div class="el-upload__tip" slot="tip">
									<a @click="exportDuiZhangData()" target="_blank"
									style="margin-left:10px;color: #409EFF; font-size: 12px; cursor: pointer;"><i class="el-icon-download"></i> 数据下载 </a>
							</div> -->
						</el-upload>
					</el-form-item>
					<el-form-item label="发票:" prop="invioce_lr_id">
						<el-select v-model="addInvoiceForm.invioce_lr_id" filterable remote placeholder="请选择发票" multiple clearable
							:remote-method="getInviocelrId" style="width:100%;">
							<el-option v-for="item in options.invioce_lr_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="sumInvoice() > 0">
						<p style="color:red;">票面金额总计： {{ sumInvoice() }} 元</p>
					</el-form-item>
					<el-form-item label="开票方">
						<el-radio-group v-model="addInvoiceForm.receive_type" @input="getNewSupplier">
							<el-radio label="OLD">原开票方</el-radio>
							<el-radio label="NEW">其他开票方</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="其他供应商" prop="supplier_id" v-if="addInvoiceForm.receive_type == 'NEW'">
						<el-select style="width:100%;" v-model="addInvoiceForm.supplier_id" filterable remote placeholder="请选择供应商"
							clearable @change="(val) => getInvoiceInfo(val, 1)" :remote-method="getSupplierNew">
							<el-option v-for="item in options.new_supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开票信息" prop="invoice_id">
						<el-select v-model="addInvoiceForm.invoice_id" filterable placeholder="请选择开票信息" clearable
							style="width:100%;">
							<el-option v-for="item in options.invoice_id_options" :key="item.value"
								:label="item.label + '/' + item.info" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addOrderInvoice()" :size='size'>提交</el-button>
				<el-button :size='size' @click="addInvoiceVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--上传刊例价-->
		<el-dialog title="批量更新刊例价" :close-on-click-modal="false" :visible.sync="priceFormVisiable" v-loading="loading"
			width="40%">
			<el-form :model="priceForm" ref="priceForm" :size="size" :rules="rules.priceForm" label-width="130px">
				<div>
					<el-form-item label="上传文件:" prop="excel_file">
						<el-upload drag ref="upload_excel_file" accept=".xls,.xlsx" action
							:http-request="(file) => { return imggreySuccess(file, 'excel_file_files') }"
							:file-list="uploadForm.excel_file_list"
							:on-remove="(file) => handleRemoveUpload2(file, 'excel_file_list')" :auto-upload="false"
							:on-exceed="limitMessage" :limit='1'>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text" style="font-size: 12px;">将文件拖到此处，或<em>点击上传</em><br /><span>支持 .xls
									.xlsx</span>
							</div>
							<div class="el-upload__tip" slot="tip"><a @click="downloadTemplate('price')" target="_blank"
									style="color: #409EFF; font-size: 12px; cursor: pointer;"><i class="el-icon-download"></i> 文件模板下载</a>
							</div>
						</el-upload>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addPrice()" :size='size'>提交</el-button>
				<el-button :size='size' @click="priceFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="tipsVisible" :close-on-click-modal="false" :close-on-press-escape="false"
			@close="closeTips()" width="70%">
			<div class="k-page-common" style="max-height:calc(100vh - 400px); overflow: auto; height: auto !important;">
				<div class="k-common-con" style="margin: 0; flex:none; display: block;">
					<div class="kBill" style="height: auto;">
						<div class="title" style="color: #F56C6C;">
							<div>{{ tipsMsg }}</div>
							<div v-if="tableData2.data.length > 0">
								<el-link type="primary" :underline="false" @click="exportErrorData(tableData2.path)"
									icon="el-icon-download">下载</el-link>
							</div>
						</div>
						<div style="padding-top: 10px; border-top: 1px solid #EBEEF5;" v-if="tableData2.data.length > 0">
							<el-table :data="tableData2.data" style="width: 100%" row-key="id" border stripe ref="table2"
								highlight-current-row>
								<el-table-column prop="task_id" label="订单编号" min-width="200">
								</el-table-column>
								<el-table-column prop="execute_id" label="执行明细编码" min-width="200">
								</el-table-column>
								<el-table-column prop="msg" label="详情" align="center" width="100">
									<template slot-scope="scope">
										<el-popover placement="left" width="330" v-if="scope.row.msg.length > 0" trigger="hover">
											<div class="ressupplier">
												<div v-for="(item, index) in scope.row.msg" :key="index">
													<div class="str" style="font-weight: normal;">{{ item }}</div>
												</div>
											</div>
											<el-button type="text" size="small" class="c-danger" slot="reference">查看</el-button>
										</el-popover>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="tipsVisible = false" :size="size">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="tipsInvoiceVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" width="70%">
			<div class="k-page-common" style="max-height:calc(100vh - 400px); overflow: auto; height: auto !important;">
				<div class="k-common-con" style="margin: 0; flex:none; display: block;">
					<div class="kBill" style="height: auto;">
						<div class="title" style="color: #F56C6C;">
							<div>错误:{{ tipsInvoiceMsg }}</div>
						</div>
						<div style="padding-top: 10px; border-top: 1px solid #EBEEF5;" v-if="tableData3.length > 0">
							<el-table :data="tableData3" style="width: 100%" row-key="id" border stripe ref="table3"
								highlight-current-row>
								<el-table-column type="index" label="序号" width="60"></el-table-column>
								<el-table-column prop="execute_id" label="执行明细编码" min-width="100">
								</el-table-column>
								<el-table-column prop="msg" label="详情" align="center" min-width="200">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="tipsInvoiceVisible = false" :size="size">确 定</el-button>
			</span>
		</el-dialog>
		<!-- <el-dialog :visible.sync="dialogVisibleImg">
			<img width="100" :src="dialogImageUrl" alt="">
		</el-dialog> -->
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			loading: false,
			disabledupload: true,
			isDownloading: false,
			dialogImageUrl: '',
			dialogVisibleImg: false,
			priceFormVisiable: false,
			addInvoiceVisiable: false,
			addFormVisiable: false,
			editFormVisiable: false,
			checkSkVisiable: false,
			tipsVisible: false,
			tipsInvoiceVisible: false,
			disabled: true,
			activeName: 'first',
			size: 'mini',
			timeRangeValue: [],
			options: {
				menus_options: [],
				agent_id_options: []
			},
			priceForm: {
				file_name: '',
				platform_id: '',
				excel_file: '',
			},
			addInvoiceForm: {
				excel_file: '',
				platform_id: '',
				invioce_lr_id: [],
				invoice_id: '',
				receive_type: 'OLD',
				supplier_id: '',
			},
			addForm: {
				excel_file: '',
				agent_id: '',
				file_name: '',
				platform_id: ''
			},
			editForm: {
				platform_name: '',
				is_choose: '',
				company_service_rate: '',
				personal_service_rate: '',
				attachment: ''
			},
			rules: {
				editForm: {
					'platform_name': [
						{ required: true, message: '请填写平台名称', trigger: ['change', 'blur'] },
						{ max: 50, message: '请填写正确的平台名称，长度不超过 50', trigger: ['change', 'blur'] }
					],
					'is_choose': [
						{ required: true, message: '请选择是否可选', trigger: ['change', 'blur'] }
					],
					'attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.editForm.attachment.length < 1) {
									callback(new Error('请上传开户证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				priceForm: {
					'excel_file': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.uploadForm.excel_file_files.length < 1 && this.uploadForm.excel_file_list.length < 1) {
									callback(new Error('请上传文件'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				addForm: {
					'agent_id': [
						{ required: true, message: '请选择下单账号', trigger: ['change', 'blur'] }
					],
					'excel_file': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.uploadForm.excel_file_files.length < 1 && this.uploadForm.excel_file_list.length < 1) {
									callback(new Error('请上传文件'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				addInvoiceForm: {
					'excel_file': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.uploadInvoiceForm.excel_file_files.length < 1 && this.uploadInvoiceForm.excel_file_list.length < 1) {
									callback(new Error('请上传文件'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invioce_lr_id': [
						{ required: true, message: '请选择发票', trigger: ['change', 'blur'] }
					],
					'invoice_id': [
						{ required: true, message: '请选择开票信息', trigger: ['change', 'blur'] }
					],
					'supplier_id': [
						{ required: true, message: '请选择供应商', trigger: ['change', 'blur'] }
					],
				},
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			multipleSelection: [],
			uploadForm: {
				excel_file_list: [],//银行流水
				excel_file_files: []
			},
			uploadInvoiceForm: {
				excel_file_list: [],//银行流水
				excel_file_files: []
			},
			options: {
				invioce_lr_id_options: [],
				new_supplier_id_options: [],
				invoice_id_options: []
			},
			tipsMsg: '',
			tipsInvoiceMsg: '',
			tableData3: [],
			tableData2: {
				data: [],
				path: ''
			},
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		this.handleSearch(this.searchForm);
	},
	methods: {
		handleError (time) {
			const startDate = new Date(time[0]);
			const endDate = new Date(time[1]);
			// 计算两个日期之间的毫秒差
			const diffTime = endDate - startDate;
			// 将毫秒转换为天数
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			// 判断天数差是否大于一年
			if (diffDays > 360) {
				this.$message.error('时间范围最多不能超过一年');
				this.timeRangeValue = [];
			}
		},
		// 下载对账数据
		exportDuiZhangData () {
			if (this.timeRangeValue.length <= 0) {
				this.$message.error('请先选择时间范围');
				return;
			}
			// this.$prompt('请输入邮箱', '提示', {
			//     confirmButtonText: '确定',
			//     cancelButtonText: '取消',
			//     inputValidator: (value) => {
			// 			if (!value) {
			// 				return '任务名称不能为空';
			// 			} else if (value.length > 20) {
			// 				return '任务名称不能超过20个字符';
			// 			}
			// 		},
			//     inputErrorMessage: '请输入任务名称'
			// }).then(({ value }) => {
			// 	this.$message({
			// 		type: 'success',
			// 		message: '你的邮箱是: ' + value
			// 	});
			// })
			this.isDownloading = true; // 设置下载状态为true
			this.$api.get('/admin/customers/export/exportplateforminvoiceexcel', { downloadType: 'platform_invoice', platform_id: this.addInvoiceForm.platform_id, timeRangeValue: this.timeRangeValue }).then(res => {
				// if (res.code == 0) {
				// 		this.$alert('异步下载任务【平台收票列表下载】创建成功！请稍后查看下载列表', '下载提示', {
				// 			confirmButtonText: '确定',
				// 		});
				// }else{
				// 	this.$message({
				// 		type: 'error',
				// 		message: res.msg
				// 	});
				// }
				// this.isDownloading = false;

				// 将Blob转换为URL以便创建一个可下载的链接
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '平台收票数据表.xlsx'); // 设置下载文件名
				document.body.appendChild(link);
				link.click(); // 触发点击下载
				document.body.removeChild(link); // 下载后移除元素
				window.URL.revokeObjectURL(url); // 释放URL对象
				this.isDownloading = false
				this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
					confirmButtonText: '确定',
				});
			})
		},
		sumInvoice () {
			var cost = 0
			this.options.invioce_lr_id_options.forEach(item => {
				if (this.addInvoiceForm.invioce_lr_id.indexOf(item.value) != -1) {
					cost += parseFloat(item.used_cost)
				}
			})
			return cost.toFixed(2)
		},
		getInviocelrId (query) {
			query = query || '';
			this.$api.get('/admin/customers/customer/getinvioceentryselect', { 'query': query, 'invoice_status': 1, status: true }).then(res => {
				if (res.code === 0) {
					this.options.invioce_lr_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getInvoiceInfo (value, type) {
			var post_data = {}
			if (type == 3) {
				post_data = {
					sid: value,
					relevance: type,
					// is_platform_order: 'YES',
					is_platform_view: 'platform_id'
				}
			} else {
				post_data = {
					sid: value,
					relevance: type,
					// is_platform_order: 'NO',
					is_platform_view: 'supplier_id'
				}
			}
			this.$api.get('/admin/resources/resources/supinvoicedw', post_data).then(res => {
				if (res.code === 0) {
					this.options.invoice_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		openPlatformInvoice () {
			this.timeRangeValue = [];
			this.uploadInvoiceForm.excel_file_files = []
			this.uploadInvoiceForm.excel_file_list = []
			this.addInvoiceForm = {
				excel_file: '',
				platform_id: '',
				invioce_lr_id: [],
				invoice_id: '',
				receive_type: 'OLD',
				supplier_id: '',
			}
			this.$nextTick(() => {
				this.$refs['addInvoiceForm'].clearValidate();
			});
			if (this.multipleSelection.length > 0) {
				this.addInvoiceForm.platform_id = this.multipleSelection[0].id
				this.getInviocelrId()
				this.getInvoiceInfo(this.multipleSelection[0].id, 3)
				this.addInvoiceVisiable = true
			}
		},
		getSupplierNew (query) {
			query = query ? query : '';
			this.$api.get('/admin/resources/resources/supldwn', { query: query }).then(res => {
				if (res.code === 0) {
					this.options.new_supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getNewSupplier (value) {
			this.addInvoiceForm.supplier_id = ''
			this.addInvoiceForm.invoice_id = ''
			if (value == 'NEW') {
				this.getSupplierNew()
			} else {
				this.getInvoiceInfo(this.addInvoiceForm.platform_id, 3)
			}
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		exportErrorData (file_name) {
			this.$api.get('/admin/customers/export/exporterrorexcel', { 'file_name': file_name }).then(res => {

				// 将Blob转换为URL以便创建一个可下载的链接
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement('a');
				link.href = url;
				const parts = file_name.split('-');
				link.setAttribute('download', '平台对账失败信息表.xlsx'); // 设置下载文件名
				document.body.appendChild(link);
				link.click(); // 触发点击下载
				document.body.removeChild(link); // 下载后移除元素
				window.URL.revokeObjectURL(url); // 释放URL对象

			})
		},
		downloadTemplate: function (type) {
			var file_name = ''
			if (type == 'order') {
				file_name = `上传订单-${this.multipleSelection[0].platform_name}.xlsx`
			} else if (type == 'price') {
				file_name = `导入刊例价-${this.multipleSelection[0].platform_name}.xlsx`
			}
			this.$api.get('/admin/customers/export/exporttemplate', { 'file_name': file_name }).then(res => {
				if (res.status == 207) {
					let reader = new FileReader(); // 创建读取文件对象
					reader.readAsText(res.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
					reader.addEventListener("loadend", function () { // 
						let res = JSON.parse(reader.result); // 返回的数据
						this.$message.error(res.msg)

					}.bind(this))
				} else {
					// 将Blob转换为URL以便创建一个可下载的链接
					const url = window.URL.createObjectURL(new Blob([res]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', file_name); // 设置下载文件名
					document.body.appendChild(link);
					link.click(); // 触发点击下载
					document.body.removeChild(link); // 下载后移除元素
					window.URL.revokeObjectURL(url); // 释放URL对象
					this.tipsVisible = false

				}

			})
		},
		//列表查询
		handleSearch (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/resources/resources/platformlist', param).then(res => {
				if (res.code == 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		//编辑弹窗
		handleTableEditOpen (row) {
			this.$api.get('/admin/resources/resources/platforminfo', { id: row.id }).then(res => {
				if (res.code == 0) {
					this.editForm = res.data
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//编辑平台
		editplatform () {
			const formData = new FormData()
			for (const key in this.editForm) {
				if (key == 'attachment') {
					if (this.editForm[key].length > 0) {
						this.editForm[key].forEach(item => {
							formData.append(key, item)
						})
					}
				} else {
					formData.append(key, this.editForm[key]);
				}
			}
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/editplatform', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch('', this.tableData.page);
							this.$message({
								showClose: true,
								message: '平台信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		//删除平台
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该平台, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/resources/resources/delplatform', { id: row.id }).then(res => {
					if (res.code == 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							} else if (item.children) {
								item.children.forEach(function (value, key) {
									if (value.id == row.id) {
										this.$delete(item.children, key);
									}
								}.bind(this));
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该平台已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//点击查看大图
		// viewImg (file) {
		// 	this.dialogImageUrl = file.url;
		// 	// if (!file.path) {
		// 	// 	this.dialogImageUrl = URL.createObjectURL(file);
		// 	// } else {
		// 	// 	this.dialogImageUrl = file.path;
		// 	// }
		// 	this.dialogVisibleImg = true;
		// },
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}
		},
		onSelectAll () {
			this.$refs.table.clearSelection();
		},
		selectItem (rows) {
			if (rows.length > 1) {
				const newRows = rows.filter((it, index) => {
					if (index == rows.length - 1) {
						this.$refs.table.toggleRowSelection(it, true);
						return true;
					} else {
						this.$refs.table.toggleRowSelection(it, false);
						return false;
					}
				});
				this.multipleSelection = newRows;
			} else {
				this.multipleSelection = rows;
				this.disabled = true
			}
			if (this.multipleSelection.length > 0 && (this.multipleSelection[0].id == 2 || this.multipleSelection[0].id == 8)) {
				this.disabled = true
			} else {
				this.disabled = false
			}
			if (this.multipleSelection.length > 0 && (this.multipleSelection[0].id == 7 || this.multipleSelection[0].id == 10)) {
				this.disabledupload = true
			} else {
				this.disabledupload = false
			}
			if (this.multipleSelection.length == 0) {
				this.disabled = true
			}
		},
		onSelectOp (row) {
			this.$refs.table.clearSelection();
			this.$refs.table.toggleRowSelection(row, true);
			this.multipleSelection = [];
			this.multipleSelection.push(row);
		},
		//上传订单弹窗打开
		openUpload () {
			this.addForm.file_name = ''
			this.addForm.agent_id = ''
			this.uploadForm.excel_file_files = []
			this.uploadForm.excel_file_list = []
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			if (this.multipleSelection.length > 0) {
				this.addForm.platform_id = this.multipleSelection[0].id
				this.addForm.file_name = "上传订单-" + this.multipleSelection[0].platform_name
				this.addFormVisiable = true
				this.$api.get('/admin/resources/resources/getagentselect').then(res => {
					if (res.code === 0) {
						this.$set(this.options, 'agent_id_options', res.data);
						// this.options.agent_id_options = res.data
					}
				})
			} else {
				this.$message.error('请选择操作项');
			}
		},
		//上传刊例弹窗打开
		openUploadPrice () {
			this.priceForm.file_name = ''
			this.uploadForm.excel_file_files = []
			this.uploadForm.excel_file_list = []
			if (this.multipleSelection.length > 0) {
				this.priceForm.file_name = "导入刊例价-" + this.multipleSelection[0].platform_name
				this.priceForm.platform_id = this.multipleSelection[0].id
				this.priceFormVisiable = true
			} else {
				this.$message.error('请选择操作项');
			}
		},
		// 上传收票数据
		addOrderInvoice () {
			if (this.$refs.upload_invoice_file) {
				this.uploadInvoiceForm.excel_file_files = []
				this.$refs.upload_invoice_file.submit()
			}
			const formData = new FormData()
			for (const key in this.addInvoiceForm) {
				if (key == 'invioce_lr_id') {
					if (this.addInvoiceForm[key].length > 0) {
						this.addInvoiceForm[key].forEach(item => {
							formData.append(key, item)
						})
					}
				} else {
					formData.append(key, this.addInvoiceForm[key]);
				}
			}
			//订单文件
			if (this.uploadInvoiceForm.excel_file_files.length > 0) {
				this.uploadInvoiceForm.excel_file_files.forEach(item => {
					formData.append('excel_file', item)
				})
			}
			this.$refs['addInvoiceForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/uploadinvoicelist', formData).then(res => {
						if (res.code === 0) {
							this.$message.success('请前往【财务】模块【收票申请】中提交审批或查看！');
							this.addInvoiceVisiable = false;
						} else {
							// 重新加载表格
							this.tipsInvoiceVisible = true;
							this.tipsInvoiceMsg = res.msg;
							this.tableData3 = res.data;
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		//上传订单
		addOrder () {
			if (this.$refs.upload_excel_file) {
				this.uploadForm.excel_file_files = []
				this.$refs.upload_excel_file.submit()
			}
			const formData = new FormData()
			for (const key in this.addForm) {
				if (this.addForm[key]) {
					formData.append(key, this.addForm[key]);
				}
			}
			//订单文件
			if (this.uploadForm.excel_file_files.length > 0) {
				this.uploadForm.excel_file_files.forEach(item => {
					formData.append('excel_file', item)
				})
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/uploadorderlist', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.addFormVisiable = false;
							this.tipsMsg = res.msg
							this.tableData2.data = res.data
							this.tableData2.path = res.other.excel_name
							this.tipsVisible = true
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		//上传刊例价
		addPrice () {
			if (this.$refs.upload_excel_file) {
				this.uploadForm.excel_file_files = []
				this.$refs.upload_excel_file.submit()
			}
			const formData = new FormData()
			for (const key in this.priceForm) {
				if (this.priceForm[key]) {
					formData.append(key, this.priceForm[key]);
				}
			}
			//订单文件
			if (this.uploadForm.excel_file_files.length > 0) {
				this.uploadForm.excel_file_files.forEach(item => {
					formData.append('excel_file', item)
				})
			}
			this.$refs['priceForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/uploadprice', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.priceFormVisiable = false;
							this.$message.success('批量更新刊例价成功！');
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		limitMessage: function (files, fileList) {
			this.$message({
				showClose: true,
				message: `本次选择了 ${files.length} 个文件,超出最大要求数量限制`,
				type: 'warning'
			})
		},
		imggreySuccessInvoice: function (files, field) {
			this.uploadInvoiceForm[field].push(files.file)
		},
		handleRemoveUploadInvoice (file, formobj) {
			this.uploadInvoiceForm[formobj] = []
		},
		imggreySuccess: function (files, field) {
			this.uploadForm[field].push(files.file)
		},
		handleRemoveUpload2 (file, formobj) {
			this.uploadForm[formobj] = []
		},
		closeTips () {
			this.$refs.table.toggleAllSelection(false);
			this.multipleSelection = []
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'PlatformDetail',
				query: { id: row.id, type: 'detail' }
			});
		},
	}
}
</script>
<style lang="scss" scoped>
.kBill .title {
	border-bottom: none !important;
	color: #409EFF;
}
</style>